const traverse2 = require("traverse");

/**
 * tabularizeFormData - Turn DM style form data into an object that can be more easily represented as tables
 */
const objHasChildren = obj =>
  Object.keys(obj).some(k => typeof obj[k] === "object");

const tabularizeFormData = data => {
  // remove @attributes and keys that are just named "_"
  // also convert all numeric values that are inside strings to numbers ("1"-->1)
  // eslint-disable-next-line
  traverse2(data).forEach(function(value) {
    if (this.key && (this.key.startsWith("@") || this.key === "_")) {
      this.remove();
    }
    // eslint-disable-next-line
    else if (!isNaN(value)) this.update(Number(value));
  });

  // remove all empty objects
  // eslint-disable-next-line
  traverse2(data).forEach(function(value) {
    if (this.key && typeof value === "object" && !Object.keys(value).length)
      this.remove();
  });

  let vals = {};

  const traverse = (jsonObj, arrName = "") => {
    if (jsonObj !== null && typeof jsonObj === "object") {
      Object.entries(jsonObj).forEach(([key, value]) => {
        // this is a leaf on the tree, an object that doesn't have any objects inside it
        // these are keepers for sure - an object with children and nothing below them
        if (!objHasChildren(value) && typeof value === "object") {
          // if (typeof value === "object" ) {
          let newKey;
          if (arrName.length) newKey = arrName;
          else newKey = key;
          if (!vals[newKey]) vals[newKey] = [];
          vals[newKey].push(value);
        }

        if (Array.isArray(value)) traverse(value, key);
        else traverse(value);
      });
    }
  };

  traverse(data);
  let sites = {};

  // special case - create the sites table
  if (
    traverse2(data).has(["inputs", "Site"]) &&
    Array.isArray(data.inputs.Site)
  ) {
    const dataClone = traverse2.clone(data.inputs.Site);
    dataClone.forEach(obj => {
      // each element in site is an object with child objects
      // eslint-disable-next-line
      Object.entries(obj).forEach(([k, v]) => {
        // eslint-disable-next-line
        if (typeof obj[k] === "object") delete obj[k];
      });
    });
    sites = { Sites: dataClone };
  }

  vals = { ...vals, ...sites };
  const newVal = {};
  // vals is an object where each key refers to an array of objects
  // remove arrays that have fewer than 2 records
  Object.entries(vals).forEach(([key, array]) => {
    if (array.length > 1) newVal[key] = array;
  });
  return newVal;
};
export default tabularizeFormData;
